import { defineStore } from "pinia";
import { signKey } from "./tokenName";


export const useSign = defineStore("sign", {
    state: () => ({
        Sign: useCookie(signKey) ?? "",
        ossSign: '',
    }),
    actions: {
        initUploadSign(newSign: string) {
            this.Sign = newSign;
        },
        setOSSSign(ossSign: string) {
            this.ossSign = ossSign;
        }
    }
});